import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "stockWarnTips" }
const _hoisted_2 = { class: "additionStockWarnContent" }
const _hoisted_3 = { class: "flex-ter" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/error_img.png",
  alt: "",
  style: {"width":"100%"}
}, null, -1)
const _hoisted_5 = { style: {"margin-right":"4px"} }
const _hoisted_6 = ["onClick"]

import { ref } from 'vue'
import { t } from '@/plugins/i18n'
import store, { useRtfix } from '@/store'
import { selectInsufficientInventory, updateEarlyWarningFlag } from '@/apis/addition'
import STable from '@/components/Table/index.vue'
import { dayjs, ElMessage } from 'element-plus'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { useRouter } from 'vue-router'
import { debounce } from 'lodash'

export default /*#__PURE__*/_defineComponent({
  props: ['zIndex'],
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props


const router = useRouter()
const visible = ref(false)
const list = ref<any>([])

const getData = async () => {
  const res = await selectInsufficientInventory()
  if (res.code !== '0') {
    return
  }
  if (!res.data) return
  list.value = res.data
  if (!list.value.length) return
  visible.value = true
  localStorage.setItem('lastAdditionDialogTime' + store.getters.curShop, dayjs().format('YYYY-MM-DD'))
}

const time = localStorage.getItem('lastAdditionDialogTime' + store.getters.curShop)
if (time !== dayjs().format('YYYY-MM-DD')) {
  getData()
}

const columns = [
  {
    label: t('辅料名称'),
    prop: 'ingredientsNameJp',
    slotName: 'ingredientsNameJp',
    width: 200
  },
  {
    label: t('資材SKU'),
    prop: 'ingredientsSku',
    width: 300
  },
  {
    label: t('資材良品数'),
    prop: 'useable',
    slotName: 'useable',
    align: 'center'
  },
  {
    label: t('操作'),
    prop: 'action',
    slotName: 'action',
    width: 160,
    align: 'center',
    event: debounce((row: any) => {
      // console.log(row)
      updateEarlyWarningFlag({
        earlyWarningFlag: 0,
        ingredientsSku: row.ingredientsSku
      }).then(res => {
        ElMessage.success(t('设置成功，下次该辅料不再提醒'))
      })
    }, 500)
  }
]

const tableConfig = {
  setHeight: true
}

const ok = () => {
  const ingredientsSkuList = list.value.map((v: any) => v.ingredientsSku).join(',')
  router.push(useRtfix('stock', { query: { stock: 'materials' }, params: { ingredientsSkuList: ingredientsSkuList } }))
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createBlock(CommonDialog, {
    visible: visible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
    width: 800,
    onOk: ok,
    onCancel: _cache[1] || (_cache[1] = () => { visible.value = false }),
    title: _unref(t)('辅料不足预警'),
    footer: true,
    zIndex: __props.zIndex,
    cancelText: _unref(t)('稍后处理'),
    okText: _unref(t)('立即查看')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('您有X个辅料库存不足，请及时补货！').replace('X', list.value.length)), 1),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(STable, {
          columns: columns,
          tableConfig: tableConfig,
          showPagination: false,
          tableData: list.value,
          maxHeight: "500px",
          class: "additionStockWarnTable"
        }, {
          ingredientsNameJp: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_image, {
                src: row.ingredientsImg,
                class: "previewImage",
                "preview-src-list": [row.ingredientsImg],
                style: {},
                "preview-teleported": true,
                "z-index": 9999
              }, {
                error: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["src", "preview-src-list"]),
              _createElementVNode("span", null, _toDisplayString(row.ingredientsNameJp), 1)
            ])
          ]),
          useable: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_5, _toDisplayString(row.useable), 1)
          ]),
          action: _withCtx(({ row, column }) => [
            _createElementVNode("span", {
              onClick: ($event: any) => (column.event(row)),
              class: "fcolor cursor-pt"
            }, _toDisplayString(_unref(t)('下次不再提醒')), 9, _hoisted_6)
          ]),
          _: 1
        }, 8, ["tableData"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "title", "zIndex", "cancelText", "okText"]))
}
}

})